import React from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { AppTransfer } from "misc/transfer";

const CustomerApps = ({ form, name, value }) => {
    const [t] = useTranslation();

    const handleTransferChange = targetKeys => {
        form.setFieldsValue({ [name]: targetKeys });
    };

    return (
        <Form form={form} initialValues={{ [name]: value }}>
            <Form.Item
                name={name}
                rules={[
                    {
                        required: false,
                        message: t("t_role_apps_is_required")
                    }
                ]}
            >
                <AppTransfer onChange={handleTransferChange} />
            </Form.Item>
        </Form>
    );
};

CustomerApps.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.array
};

export default CustomerApps;
